import { GetTemplates } from '@/connection/templates';
import { ContentReducerCreator } from '../types';

const loadTemplatesReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (channel: number) => {
      return await GetTemplates(channel);
    },
    {
      pending: (state) => {
        state.loadingContent = true;
      },
      fulfilled: (state, action) => {
        state.templates = action.payload;
      },
      settled: (state) => {
        state.loadingContent = false;
      },
    }
  );
};

export default loadTemplatesReducer;
